/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Quiet_Hawk_SoarInputs */

const en_bold_quiet_hawk_soar = /** @type {(inputs: Bold_Quiet_Hawk_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rounding strategy`)
};

const de_bold_quiet_hawk_soar = /** @type {(inputs: Bold_Quiet_Hawk_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rundungsstrategie`)
};

/**
* | output |
* | --- |
* | "Rounding strategy" |
*
* @param {Bold_Quiet_Hawk_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_quiet_hawk_soar = /** @type {((inputs?: Bold_Quiet_Hawk_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Quiet_Hawk_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_quiet_hawk_soar(inputs)
	return de_bold_quiet_hawk_soar(inputs)
});